import { useQuery } from "@tanstack/react-query";

import { usePagedEntity } from "../usePagedEntity";
import { getAllOrganizations, getOrganizationById } from "./organizations";

export const organizationQueryKeys = {
    all: ["organizations"] as const,
    context: ["frontend-organizationContext"] as const,
    page: (page: number, size: number, search: string) =>
        ["organizations", { page, size, search }] as const,
    detail: (id: number) => ["organizations", "detail", id] as const,
};

export interface OrganizationPagesQuery {
    pageCount: number;
    size: number;
    search: string;
    enabled?: boolean;
}

export function useOrganizationPages({
    pageCount,
    size,
    search,
    enabled,
}: OrganizationPagesQuery) {
    return usePagedEntity({
        pageCount,
        size,
        search,
        enabled,
        queryKey: ({ page, size: pageSize, search: normalizedSearch }) =>
            organizationQueryKeys.page(page, pageSize, normalizedSearch),
        queryFn: ({ page, size: pageSize, search: normalizedSearch }) =>
            getAllOrganizations(
                page,
                pageSize,
                undefined,
                normalizedSearch || undefined
            ),
    });
}

export function useOrganizationById(id: number | null) {
    return useQuery({
        queryKey: organizationQueryKeys.detail(id ?? 0),
        queryFn: () => getOrganizationById(id!),
        enabled: id !== null,
        staleTime: 30_000,
    });
}
